/**
 * The slot `getPartnerConfig` and `sourceActionsComponent` share. Only
 * `SourceCardActions` is inside the Chat globs; `getPartnerConfig` shares
 * its slot.
 *
 * So Chat fills the slot — `src/components/chat/components/evidence-answer-ports.ts`
 * calls the registrar at module scope — and the host beside this file reads it,
 * which leaves every composition point free of a Chat import.
 *
 * A separate module from the host so the host exports components only
 * (react-refresh).
 */

import type { EvidenceAnswerPorts } from '@heidi/evidence';

/** The two members that share this slot. */
export type EvidenceAnswerChatPorts = Pick<
  EvidenceAnswerPorts,
  'getPartnerConfig' | 'sourceActionsComponent'
>;

let registered: EvidenceAnswerChatPorts | null = null;

/** Called ONCE at module scope, from inside the Chat quarantine globs. */
export const registerEvidenceAnswerChatPorts = (ports: EvidenceAnswerChatPorts): void => {
  registered = ports;
};

/**
 * Read the pair. Throws rather than degrading: an answer surface with no
 * partner branding and no source actions renders as a plausible card, so a
 * missing registration has to be loud.
 */
export const resolveEvidenceAnswerChatPorts = (): EvidenceAnswerChatPorts => {
  if (registered === null) {
    throw new Error(
      'EvidenceAnswerPorts: getPartnerConfig and sourceActionsComponent are unregistered — ' +
        'src/components/chat/components/evidence-answer-ports.ts has not been loaded.'
    );
  }
  return registered;
};

/** Test-only: drop the registered pair between tests. */
export const __resetEvidenceAnswerChatPortsForTests = (): void => {
  registered = null;
};
